import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import FormFooter from './FormFooter';
import FormField from './FormField';

const StandardForm = ({
    formFields,
    submitText,
    submitForm,
    errors,
    touched,
    values,
    removeSubmit,
    isSubmitting,
}) => (
    <form
        onSubmit={(event) => {
            event.preventDefault();
            submitForm();
        }}
    >
        <Grid container spacing={3}>
            {formFields.map((field, index) => (
                <FormField
                    key={index}
                    field={field}
                    index={index}
                    errors={errors}
                    touched={touched}
                    values={values}
                />
            ))}
        </Grid>
        <FormFooter
            submitText={submitText}
            isSubmitting={isSubmitting}
            removeSubmit={removeSubmit}
        />
    </form>
);

export default StandardForm;

StandardForm.propTypes = {
    errors: PropTypes.object,
    formFields: PropTypes.array.isRequired,
    formType: PropTypes.string,
    initialValues: PropTypes.object,
    submitForm: PropTypes.func.isRequired,
    submitText: PropTypes.string,
    touched: PropTypes.object,
    values: PropTypes.object,
};

StandardForm.defaultProps = {
    errors: null,
    formType: 'standard',
    initialValues: null,
    submitText: 'Submit',
    touched: null,
    values: null,
};
